// PrivateNoIndex — Lot 14B.
// À insérer dans toutes les routes non-publiques pour forcer noindex,nofollow.

import { Helmet } from "react-helmet-async";

const PrivateNoIndex = () => (
  <Helmet>
    <meta name="robots" content="noindex,nofollow" data-testid="meta-noindex" />
    <meta name="googlebot" content="noindex,nofollow" />
  </Helmet>
);

export default PrivateNoIndex;
